import { IShipmentLineItem, SourceSystem } from '@rygen/rygen-ui/model';
import { ShipmentOrderReference } from '@rygen/rygen-ui/model/shipmentFinancials';

import { LineItem } from '../LineItem';
import { BillingShipmentLineItem } from '../shipmentFinancials/BillingShipmentLineItem';

const TYPE = 'Shipment';

export class ShipmentLineItem extends LineItem implements IShipmentLineItem {
  orderId?: number;
  shipOrderId?: number;
  shipOrderLineItemId?: number;
  pickupStopId?: number;
  dropOffStopId?: number;

  constructor(opts?: Partial<ShipmentLineItem>) {
    super(opts);
    this.type = TYPE;

    if (opts?.orderId != null) {
      this.orderId = opts.orderId;
    }
    if (opts?.shipOrderId != null) {
      this.shipOrderId = opts.shipOrderId;
    }
    if (opts?.shipOrderLineItemId != null) {
      this.shipOrderLineItemId = opts.shipOrderLineItemId;
    }
    if (opts?.pickupStopId != null) {
      this.pickupStopId = opts.pickupStopId;
    }
    if (opts?.dropOffStopId != null) {
      this.dropOffStopId = opts.dropOffStopId;
    }
  }

  static isShipmentLineItem(lineItem: LineItem): lineItem is ShipmentLineItem {
    return lineItem.type === TYPE;
  }

  asBillingShipmentLineItemReference(): BillingShipmentLineItem {
    const order = this.orderId
      ? new ShipmentOrderReference({
          id: this.orderId,
          sourceSystemId: this.orderId?.toString(),
          sourceSystem: SourceSystem.CORSAIR,
        })
      : undefined;

    return new BillingShipmentLineItem({
      sourceSystemId: this.id?.toString(),
      order: order,
    });
  }
}
